<template>
  <div class="content">
    <!-- 开户按钮 -->
    <el-form :inline="true" class="demo-form-inline" size="mini">
      <el-form-item>
        <el-button type="primary" @click="kaihuBtn">开户</el-button>
      </el-form-item>
    </el-form>
    <!-- 商品表格 -->
    <div style="height:80%">
      <el-table
        :data="beforArr"
        style="width: 100%"
        height="100%"
        v-loading="loading"
        :header-cell-style="{ background: '#e8effc', color: '#000' }"
      >
        <el-table-column
          type="index"
          label="序号"
          width="50"
          align="center"
        ></el-table-column>
        <!-- <el-table-column label="用户id" width="80" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.userId }}</span>
          </template>
        </el-table-column> -->
        <el-table-column label="账号名" width="150" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.sup_username }}</span>
          </template>
        </el-table-column>
        <el-table-column label="账号密码" width="100" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.sup_password }}</span>
          </template>
        </el-table-column>
        <el-table-column label="权限等级" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.role_id == 0 ? "主账号" : "子账号" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="手机号" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.supplier_phone }}</span>
          </template>
        </el-table-column>
        <el-table-column label="日期" align="center" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.create_time }}</span>
          </template>
        </el-table-column>
        <el-table-column label="备注">
          <template slot-scope="scope">
            <span>{{ scope.row.message }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" align="center">
          <template slot-scope="scope">
            <el-button size="mini" @click="ejectupdataGoods(scope.row)"
              >修改</el-button
            >
            <el-button size="mini" type="danger" @click="deleteAdmin(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        @prev-click="prevClick"
        @next-click="nextClick"
        background
        layout="prev, pager, next"
        :page-size="pageSize"
        :total="pageCount"
      ></el-pagination>-->
    </div>
    <!-- 开户表单 -->
    <el-dialog
      :title="inputTitle"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="form">
        <!-- <el-form-item label="用户id">
          <el-input v-model="form.userId" auto-complete="off"></el-input>
        </el-form-item> -->
        <el-form-item label="用户名">
          <el-input v-model="form.sup_username" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="form.sup_password" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input
            v-model="form.supplier_phone"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="权限">
          <el-select
            v-model="form.role_id"
            placeholder="请选择用户权限"
            @change="roleChange"
          >
            <div v-for="item in adminArr" :key="item.id">
              <el-option :label="item.name" :value="item.id"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="店铺" v-if="form.role_id == 1">
          <el-select
            v-model="selectStoreList"
            placeholder="请选择用店铺"
            multiple
          >
            <div v-for="item in storeList" :key="item.id">
              <el-option
                :label="item.storeName"
                :value="item.id + ''"
              ></el-option>
            </div>
          </el-select>
        </el-form-item>

        <el-form-item label="备注">
          <el-input v-model="form.message" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumbmitBtn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  selectspuser,
  addspuser,
  updatespuser,
  deletespuser,
} from "@/services/admin";
import { selectStore } from "@/services/store";
export default {
  data() {
    return {
      beforArr: [],
      inputTitle: "开户",
      loading: true,
      name: "",
      pageCount: "",
      pageSize: 8,
      adminArr: [
        { name: "最高权限", id: "0" },
        { name: "普通子账号权限", id: "1" },
      ],
      storeList: [],
      selectStoreList: [],
      form: {},
      dialogFormVisible: false,
    };
  },
  created() {
    // 查询用户登陆数据
    this.selece();
    selectStore({ storeName: "" }).then((res) => {
      this.storeList = res.data;
    });
  },
  methods: {
    // 查询
    selece() {
      selectspuser().then((resp) => {
        console.log(resp);
        this.loading = false;
        this.beforArr = resp;
        // this.$message({
        //   type: "success",
        //   message: "跟新成功!"
        // });
        // this.pageCount = resp.pageCount;
      });
    },
    // 开户按钮
    kaihuBtn() {
      this.inputTitle = "开户";
      this.dialogFormVisible = true;
      this.form = {};
    },
    ejectupdataGoods(row) {
      console.log(row);
      this.dialogFormVisible = true;
      this.inputTitle = "修改";
      this.form = row;
      this.selectStoreList = this.form.storeId.split(",");
    },
    roleChange() {
      this.form.storeId = null;
    },
    // 表单提交按钮
    sumbmitBtn() {
      console.log(this.form);
      if (this.selectStoreList.length > 0) {
        this.form.storeId = this.selectStoreList.join(",");
        console.log("this.form.storeId", this.form.storeId);
      }
      if (this.form.sup_username == "" || this.form.sup_username == null) {
        this.$message.error("请填写用户名");
        return;
      }
      if (this.form.sup_password == "" || this.form.sup_password == null) {
        this.$message.error("请填写密码");
        return;
      }
      if (this.form.supplier_phone == "" || this.form.supplier_phone == null) {
        this.$message.error("请填写手机号");
        return;
      }
      if (this.form.role_id == null) {
        this.$message.error("请选择权限");
        return;
      }
      if (this.form.message == "" || this.form.message == null) {
        this.$message.error("请填写备注");
        return;
      }
      if (this.inputTitle == "开户") {
        addspuser(this.form).then((res) => {
          console.log(res);
          if (res.status == 200) {
            this.dialogFormVisible = false;
            this.$message({
              type: "success",
              message: "开通账号成功!",
            });
            this.selece();
          } else {
            this.$message({
              type: "info",
              message: res.data,
            });
          }
        });
        return;
      }

      updatespuser(this.form).then((res) => {
        console.log(res);
        if (res.status == 200) {
          this.dialogFormVisible = false;
          this.$message({
            type: "success",
            message: "修改账号成功!",
          });
          this.selece();
        } else {
          this.$message({
            type: "info",
            message: res.data,
          });
        }
      });
    },
    // 删除
    deleteAdmin(row) {
      this.$confirm("此操作将永久删除该账号, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          console.log(row.id);
          deletespuser(row.id).then((resp) => {
            console.log(resp);
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.selece();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>

<style>
.content {
  margin: 30px auto;
  /* border:1px solid red; */
  width: 80%;
}
.el-pagination {
  text-align: center;
  margin: 20px;
}
.userNanme:hover {
  cursor: pointer;
}
</style>
